module.exports = __webpack_public_path__ + "img/1f41e.217eb05.svg";